let StarChestExtraRewardRedirector = xClass("StarChestExtraRewardRedirector", BaseRedirector)
StarChestExtraRewardRedirector.prototype.getName = function () {
    return "starChestExtraReward"
}
StarChestExtraRewardRedirector.prototype.redirect = function () {
    var self = this;
    var param = self.param;

    let um = UserManager.getInstance();
    if (!Object.keys(um.settings.data).length) {
        // um还没解析login, 等待下次执行
        return false;
    }

    function onSuccess(evt) {
        
    }
    function onFail(evt) {
        
    }
    let http = StarChestExtraRewardShareInHttp.new();
    http.addEventListener(Events.kComplete, onSuccess);
    http.addEventListener(Events.kError, onFail);
    http.addEventListener(Events.kCancel, onFail);
    http.load(param.uid, param.shareId);
    return true;
}

StarChestExtraRewardRedirector.prototype.hasHighPriorityAction = function () {
    return false;
}

module.exports = StarChestExtraRewardRedirector